import { ReportDetails } from 'model/constants';
import { IReportHistoryState } from 'model/interfaces';
import { DropdownOptionState, ReportHistoryData, ReportHistoryDetailsState, TrendCardData } from 'model/types';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const initialState = {
  isReportHistoryDetailsLoading: true,
  reportHistoryDetails: null,
  reportHistoryDemographicGroups: null,
  reportHistoryCustomGroups: null,
  selectedCustomGroup: null,
  trendCardsData: null,
  selectedPayGap: null,
  viewUnadjustedAs: ReportDetails.average,
  reportHistoryData: null,
  reTriggerReportHistoryDetails: false,
};

export const useReportHistoryStore = create<IReportHistoryState>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        updateIsReportHistoryDetailsLoading: (isReportHistoryDetailsLoading: boolean) => {
          set({ isReportHistoryDetailsLoading });
        },
        updateReportHistoryDetails: (reportHistoryDetails: ReportHistoryDetailsState[]) => {
          set({ reportHistoryDetails });
        },
        updateReportHistoryDemographicGroups: (reportHistoryDemographicGroups: string[]) => {
          set({ reportHistoryDemographicGroups });
        },
        updateReportHistoryCustomGroups: (reportHistoryCustomGroups: string[]) => {
          set({ reportHistoryCustomGroups });
        },
        updateSelectedCustomGroup: (selectedCustomGroup: DropdownOptionState | null) => {
          set({ selectedCustomGroup });
        },
        updateTrendCardsData: (trendCardsData: TrendCardData[]) => {
          set({ trendCardsData });
        },
        updateSelectedPayGap: (selectedPayGap: DropdownOptionState) => {
          set({ selectedPayGap });
        },
        updateViewUnadjustedAs: (viewUnadjustedAs: string) => {
          set({ viewUnadjustedAs });
        },
        updateReportHistoryData: (reportHistoryData: ReportHistoryData[]) => {
          set({ reportHistoryData });
        },
        updateReTriggerReportHistoryDetails: (reTriggerReportHistoryDetails: boolean) => {
          set({ reTriggerReportHistoryDetails });
        },
        resetReportHistoryData: () => {
          set(initialState);
        },
      }),
      {
        name: 'kf1-reportHistoryStore',
        storage: createJSONStorage(() => window.sessionStorage),
      },
    ),
  ),
);
